import { currentLocaleState } from '@esg/ui/state/currentLocale';
import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { GetDetailBranchResponseItem } from '../../../../../packages/business/organization/api/branch/getDetailBranch';
import i18n from 'i18next';
import { IziLanguage } from '@esg/shared';
import { getLanguageByCountryCode } from '@esg/i18n';

interface ClientReviewLocalesProviderProps {
    children: React.ReactNode;
    branch: GetDetailBranchResponseItem;
}

export default function ClientReviewLocalesProvider(props: ClientReviewLocalesProviderProps) {
    const { branch } = props;
    const [, setCurrentLocale] = useAtom(currentLocaleState);

    useEffect(() => {
        if (branch) {
            setCurrentLocale({
                country: branch.country,
                currency: branch.currency,
                timezone: branch.timezone,
                language: branch.languages,
                format: branch.dateTimeFormat,
                contact: { ...branch }
            });

            const branchLanguage = getLanguageByCountryCode(branch.country);

            if (i18n.resolvedLanguage !== branchLanguage && branchLanguage) {
                localStorage.setItem(IziLanguage, branchLanguage);
                i18n.changeLanguage(branchLanguage);
            }
        }
    }, [branch, setCurrentLocale]);

    return props.children;
}
